<template>
  <div>
    <p class="text-sm">Ой, не смогли загрузить</p>
    <UiButton
      text
      severity="secondary"
      class="mx-auto mt-3 w-fit px-7 py-2.5"
      @click="$emit('reload')"
    >
      Попробовать еще раз
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import UiButton from './UiButton.vue'

defineEmits<{
  (e: 'reload'): void
}>()
</script>
